module.exports = __webpack_public_path__ + "static/img/lab-1.ce4fbf4c.jpg";